/* ===================================================================
   Porão dos Quadros — Favoritos (wishlist) 100% client-side.
   Sem app, sem login, sem custo. Guarda um SNAPSHOT por item
   { id, handle, title, image, price, url } no localStorage.
   O id (numérico) é a chave estável — o handle pode mudar quando
   um produto é reformatado (301), então NUNCA dependemos só dele.
   =================================================================== */
(function () {
  'use strict';

  var KEY = 'pdq_wishlist_v1';
  var MAX = 100;
  var FAV_URL = '/pages/favoritos';

  /* ---------- store ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: read().length } }));
  }
  function has(id) {
    id = String(id);
    return read().some(function (it) { return String(it.id) === id; });
  }
  function add(item) {
    if (!item || !item.id) return;
    var list = read();
    if (list.some(function (it) { return String(it.id) === String(item.id); })) return;
    list.unshift(item);
    write(list);
  }
  function remove(id) {
    id = String(id);
    write(read().filter(function (it) { return String(it.id) !== id; }));
  }
  function toggle(item) {
    if (has(item.id)) { remove(item.id); return false; }
    add(item); return true;
  }

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n) || n <= 0) return '';
    return 'R$ ' + (n / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sizeImg(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=/.test(url)) return url; // já dimensionada pelo Liquid image_url
    return url.replace(/(_\d+x\d*)?(\.(?:jpe?g|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$2$3');
  }
  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-id'),
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || '',
      url: btn.getAttribute('data-url') || ''
    };
  }

  /* ---------- vistos recentemente ----------
     A home ("Continue de onde parou") precisa saber o que a pessoa acabou de ver.
     O botão de favoritos da própria PDP já carrega o snapshot completo do produto
     nos data-*, então gravar a visita não custa requisição nem markup novo. */
  var RECENT_KEY = 'pdq_recent_v1';
  var RECENT_MAX = 12;

  function readRecent() {
    try {
      var v = JSON.parse(localStorage.getItem(RECENT_KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function recordView() {
    // Serve tanto /products/<handle> quanto /collections/<x>/products/<handle>.
    var parts = location.pathname.split('/products/');
    if (parts.length < 2) return;
    var handle = parts[1].split(/[/?#]/)[0];
    if (!handle) return;

    var btns = document.querySelectorAll('[data-wishlist-toggle][data-id]');
    var me = null;
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-handle') === handle) { me = btns[i]; break; }
    }
    if (!me) return;

    var item = itemFromButton(me);
    if (!item.id) return;

    var list = readRecent().filter(function (it) { return String(it.id) !== String(item.id); });
    list.unshift(item);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) {}
  }

  /* ---------- botões (coração) ---------- */
  function paintButton(btn) {
    var active = has(btn.getAttribute('data-id'));
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var t = btn.querySelector('[data-wishlist-text]');
    if (t) {
      var lbl = active ? btn.getAttribute('data-label-on') : btn.getAttribute('data-label-off');
      if (lbl) t.textContent = lbl;
    }
    btn.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
  }
  function paintAllButtons() {
    var b = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < b.length; i++) paintButton(b[i]);
  }
  function updateBadges() {
    var n = read().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n > 9 ? '9+' : String(n);
      if (n === 0) { badges[i].setAttribute('hidden', ''); }
      else { badges[i].removeAttribute('hidden'); }
    }
  }

  /* ---------- toast (genérico: favoritos, carrinho, etc.) ---------- */
  var toastTimer;
  function toast(msg, href, label) {
    var el = document.querySelector('.wishlist-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'wishlist-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span class="wishlist-toast__msg">' + esc(msg) + '</span>' +
      (href ? '<a class="wishlist-toast__link" href="' + esc(href) + '">' + esc(label || 'Ver') + '</a>' : '');
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3400);
  }
  // Exposto pra PDP (botão de carrinho) reusar o mesmo aviso — um só elemento, um só timer.
  window.PoraoToast = toast;

  /* ---------- click delegation ---------- */
  function onClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var item = itemFromButton(btn);
    if (!item.id) return;
    var nowActive = toggle(item);
    paintButton(btn);
    updateBadges();
    if (nowActive) {
      btn.classList.add('just-added');
      setTimeout(function () { btn.classList.remove('just-added'); }, 480);
      toast('Salvo nos favoritos', FAV_URL, 'Ver favoritos');
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'add_to_wishlist', item_id: item.id, item_name: item.title }); } catch (_) {}
      try { if (window.gtag) window.gtag('event', 'add_to_wishlist', { items: [{ item_id: item.id, item_name: item.title }] }); } catch (_) {}
    } else {
      toast('Removido dos favoritos');
    }
  }

  /* ===================================================================
     Página /favoritos — renderiza do snapshot (instantâneo, zero CLS),
     depois hidrata preço/estoque em segundo plano (best-effort).
     =================================================================== */
  function favGrid() { return document.querySelector('[data-wishlist-grid]'); }

  function cardHTML(it) {
    var img = sizeImg(it.image, 400);
    var price = money(it.price);
    return '' +
      '<div class="product-card fav-card" data-wishlist-item="' + esc(it.id) + '">' +
        '<div class="product-card__image-wrap">' +
          (img ? '<img class="product-card__image--primary" src="' + esc(img) + '" alt="' + esc(it.title) + '" width="600" height="600" loading="lazy" decoding="async">' : '') +
          '<button type="button" class="wishlist-btn wishlist-btn--card is-active" data-wishlist-toggle aria-pressed="true" aria-label="Remover dos favoritos"' +
            ' data-id="' + esc(it.id) + '" data-handle="' + esc(it.handle) + '" data-title="' + esc(it.title) + '"' +
            ' data-image="' + esc(it.image) + '" data-price="' + esc(it.price) + '" data-url="' + esc(it.url) + '">' +
            heartSVG() +
          '</button>' +
        '</div>' +
        /* 07/09: os DOIS nomes, igual ao snippets/product-card.liquid (inteiro + sem o "Quadro
           Decorativo " da frente). Terceiro e último lugar do site que montava o título à mão —
           os outros são o wlRecCard da PDP e o snippet. ADITIVO: o `.pc-t-clean` nasce com
           display:none inline e o CSS global esconde de novo, então pra cliente nada muda; quem
           troca é a regra `html.previa` do snippets/previa.liquid. */
        '<h3 class="product-card__title"><span class="pc-t-full">' + esc(it.title) + '</span>' +
          '<span class="pc-t-clean" style="display:none">' +
          esc(String(it.title == null ? '' : it.title).replace(/^Quadro Decorativo Grande (.+) para (?:Sala|Quarto|Escritório|Área Gourmet|Banheiro)(?: .*)?$/, '$1').replace(/^Quadro Decorativo /, '')) + /* 25/09: nome curto do título NOVO do Ateliê ("Quadro Decorativo Grande <assunto> para <ambiente> [cor]" → só o
           <assunto>); qualquer outro título só perde o "Quadro Decorativo ". Mesma regra do product-card.liquid. */
          
          '</span></h3>' +
        '<div class="fav-card__price" data-fav-price>' + price + '</div>' +
        '<a href="' + esc(it.url || ('/products/' + it.handle)) + '" class="product-card__link" aria-label="' + esc(it.title) + '"></a>' +
      '</div>';
  }
  function heartSVG() {
    return '<svg width="20" height="20" class="wishlist-btn__icon" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  }

  function toggleEmptyState() {
    if (!document.querySelector('[data-wishlist-root]')) return;
    var n = read().length;
    var de = document.documentElement;
    de.classList.toggle('wl-has', n > 0);
    de.classList.toggle('wl-empty', n === 0);
    var countEl = document.querySelector('[data-wishlist-page-count]');
    if (countEl) countEl.textContent = n === 1 ? '1 quadro salvo' : (n + ' quadros salvos');
  }

  function renderFavPage() {
    var grid = favGrid();
    if (!grid) return;
    var list = read();
    grid.innerHTML = list.map(cardHTML).join('');
    toggleEmptyState();
    hydrate(list);
  }

  // Remove com fade os cards que saíram da lista; mostra empty state se zerou.
  function refreshFavPage() {
    var grid = favGrid();
    if (!grid) return;
    var ids = read().map(function (i) { return String(i.id); });
    var cards = grid.querySelectorAll('[data-wishlist-item]');
    for (var i = 0; i < cards.length; i++) {
      (function (c) {
        if (ids.indexOf(c.getAttribute('data-wishlist-item')) === -1) {
          c.classList.add('is-removing');
          setTimeout(function () { c.remove(); toggleEmptyState(); }, 280);
        }
      })(cards[i]);
    }
    toggleEmptyState();
  }

  // Hidratação com pool de concorrência 6. 404 (handle mudou) => mantém snapshot.
  function hydrate(list) {
    var i = 0;
    function next() {
      if (i >= list.length) return;
      var it = list[i++];
      if (!it.handle) { next(); return; }
      fetch('/products/' + it.handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var card = document.querySelector('[data-wishlist-item="' + cssEsc(it.id) + '"]');
          if (!card) return;
          var priceEl = card.querySelector('[data-fav-price]');
          if (priceEl && p.price != null) priceEl.textContent = money(p.price);
          if (p.available === false) card.classList.add('fav-card--soldout');
        })
        .catch(function () {})
        .then(next, next);
    }
    var lanes = Math.min(6, list.length);
    for (var k = 0; k < lanes; k++) next();
  }
  function cssEsc(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  /* ---------- boot ---------- */
  function initAll() {
    paintAllButtons();
    updateBadges();
    renderFavPage();
    recordView();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('wishlist:updated', function () { updateBadges(); refreshFavPage(); });
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { paintAllButtons(); updateBadges(); renderFavPage(); }
  });
  // bfcache / ativação de prerender (speculation rules) — reflete estado atual
  window.addEventListener('pageshow', function () { paintAllButtons(); updateBadges(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.PoraoWishlist = {
    read: read, add: add, remove: remove, has: has, toggle: toggle,
    KEY: KEY, refresh: renderFavPage,
    // repinta corações inseridos dinamicamente (ex: cards de relacionados do pdp.js)
    sync: function () { paintAllButtons(); updateBadges(); }
  };

  window.PoraoRecent = { read: readRecent, KEY: RECENT_KEY };
})();
